<h2 mat-dialog-title>Preview Details</h2>
<mat-dialog-content>
  <ng-container
    *ngTemplateOutlet="
      formFieldTemplate;
      context: {
        fields: data
      }
    "
  >
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    Submit
  </button>
</mat-dialog-actions>

<ng-template #formFieldTemplate let-fields="fields">
  <div class="preview-container">
    <ng-container *ngFor="let control of fields">
      <ng-container ngSwitch="{{ control.type }}">
        <ng-container *ngSwitchDefault>
          <ng-container *ngIf="control?.value">
            <div class="key-value">
              <span
                class="key"
                matBadge="C"
                matBadgePosition="before"
                matBadgeColor="warn"
                matBadgeSize="small"
                [matBadgeHidden]="control?.pristine"
              >
                {{ control.placeholder }}
              </span>
              <span class="value">
                {{ control.value }}
              </span>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'date'">
          <ng-container
            *ngTemplateOutlet="
              dateTimeTemplate;
              context: {
                control: control
              }
            "
          >
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'time'"
          ><ng-container
            *ngTemplateOutlet="
              dateTimeTemplate;
              context: {
                control: control
              }
            "
          >
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'select'">
          <ng-container
            *ngIf="
              control?.multipleSelect
                ? control?.value?.length > 0
                : !!control?.value
            "
          >
            <div class="key-value">
              <span
                class="key"
                matBadge="C"
                matBadgePosition="before"
                matBadgeColor="warn"
                matBadgeSize="small"
                [matBadgeHidden]="control?.pristine"
              >
                {{ control.placeholder }}
              </span>
              <div class="value">
                <ng-container *ngIf="control?.multipleSelect">
                  <div *ngFor="let selectedValue of control.value">
                    {{ selectedValue }}
                  </div>
                </ng-container>
                <ng-container *ngIf="!control?.multipleSelect">
                  {{ control.value }}
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'image'">
          <ng-container *ngIf="control?.value">
            <div class="key-value">
              <span
                class="key"
                matBadge="C"
                matBadgePosition="before"
                matBadgeColor="warn"
                matBadgeSize="small"
                [matBadgeHidden]="control?.pristine"
              >
                {{ control.placeholder }}
              </span>
              <span class="value">
                <img class="preview-image" [src]="control.value" alt="img" />
              </span>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'document'">
          <ng-container *ngIf="control?.value">
            <div class="key-value">
              <span
                class="key"
                matBadge="C"
                matBadgePosition="before"
                matBadgeColor="warn"
                matBadgeSize="small"
                [matBadgeHidden]="control?.pristine"
              >
                {{ control.placeholder }}
              </span>
              <span class="value">
                <a target="_blank" [href]="control.value">
                  <mat-icon class="doc">description</mat-icon>
                </a>
              </span>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'multicheckbox'"></ng-container>
        <ng-container *ngSwitchCase="'rich-textarea'"></ng-container>
        <ng-container *ngSwitchCase="'group'"></ng-container>
        <ng-container *ngSwitchCase="'array'"></ng-container>
      </ng-container>
    </ng-container>
  </div>

  <ng-container *ngFor="let control of fields">
    <ng-container ngSwitch="{{ control.type }}">
      <ng-container *ngSwitchCase="'multicheckbox'">
        <ng-container *ngIf="!control?.isGrouped && control?.value?.length">
          <div class="key-value">
            <span
              class="key"
              matBadge="C"
              matBadgePosition="before"
              matBadgeColor="warn"
              matBadgeSize="small"
              [matBadgeHidden]="control?.pristine"
            >
              {{ control.placeholder }}
            </span>
            <span class="value">
              <div *ngFor="let selectedValue of control.value">
                {{ selectedValue }}
              </div>
            </span>
          </div>
        </ng-container>
        <ng-container *ngIf="control?.isGrouped && control?.value?.length">
          <div class="key-value">
            <span
              class="key"
              matBadge="C"
              matBadgePosition="before"
              matBadgeColor="warn"
              matBadgeSize="small"
              [matBadgeHidden]="control?.pristine"
            >
              {{ control.placeholder }}
            </span>
            <div class="multicheckbox-group-container">
              <div
                class="multicheckbox-group"
                *ngFor="let group of control.value"
              >
                <div class="multicheckbox-label">
                  {{ group?.group }}
                </div>
                <div *ngFor="let each of group.values">
                  {{ each.value }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'rich-textarea'">
        <ng-container *ngIf="control?.value">
          <div class="key-value">
            <span
              class="key"
              matBadge="C"
              matBadgePosition="before"
              matBadgeColor="warn"
              matBadgeSize="small"
              [matBadgeHidden]="control?.pristine"
            >
              {{ control.placeholder }}
            </span>
            <span [MathJax]="control.value"></span>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'group'">
        <ng-container *ngIf="control?.value?.length">
          <div class="key-value">
            <span class="key">{{ control.placeholder }}</span>
            <div class="group-value">
              <ng-container
                *ngTemplateOutlet="
                  formFieldTemplate;
                  context: {
                    fields: control.value
                  }
                "
              >
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'array'">
        <ng-container *ngIf="control?.value?.length">
          <div class="key-value">
            <span class="key">{{ control.placeholder }}</span>
            <ng-container *ngFor="let arrayControl of control.value">
              <ng-container *ngIf="arrayControl?.length">
                <div class="group-value">
                  <ng-container
                    *ngTemplateOutlet="
                      formFieldTemplate;
                      context: {
                        fields: arrayControl
                      }
                    "
                  >
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #dateTimeTemplate let-control="control">
  <ng-container *ngIf="control?.value">
    <div class="key-value">
      <span
        class="key"
        matBadge="C"
        matBadgePosition="before"
        matBadgeColor="warn"
        matBadgeSize="small"
        [matBadgeHidden]="control?.pristine"
      >
        {{ control.placeholder }}
      </span>
      <div class="value">
        <ng-container *ngIf="control?.isRange">
          {{ control.value[0] }} to {{ control.value[1] }}
        </ng-container>
        <ng-container *ngIf="!control?.isRange">
          {{ control.value }}
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>
